import { Col, Form, Input, Row, Typography } from "antd";
import { BOM } from "../../../../../services/definedMethod";
const { Text } = Typography;

const PostingControls = (props) => {
  const { onFinish, form, formData, glDetail } = props;
  const displayValue = (value) =>
    value !== undefined && value !== null && value !== "" ? value : "-";
  const yesNo = (value) =>
    value === true ? "Yes" : value === false ? "No" : "-";
  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      form={form}
      initialValues={formData}
    >
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Posting Allowed</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={yesNo(glDetail?.postingAllowed)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Debit Allowed</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={yesNo(glDetail?.debitAllowed)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Credit Allowed</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={yesNo(glDetail?.creditAllowed)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Maximum Transaction Limit</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(
                BOM.FormatAmount(glDetail?.maximumTransactionLimit),
              )}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Batch Posting Allowed</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={yesNo(glDetail?.batchPostingAllowed)}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default PostingControls;
